export const pieAnalyticsOptions = {
    slices: [
        {
            color: "#195A62"
        },
        {
            color: "#2790A6"
        },
        {
            color: "#32B5D3"
        },
        {
            color: "#57CAE3"
        },
        {
            color: "#D1F3FA"
        }
    ],
    legend: "none",
    tooltip: {
        showColorCode: true
    },
    chartArea: {
        top: 8,
        bottom: 8,
        width: 600,
        height: 600,
    },
    pieHole: 0.41,
};

export const pieAnalyticsOptionsDataNone = {
    slices: [
        {
            color: "#F2F2F2"
        },
    ],
    legend: "none",
    tooltip: {
        trigger: 'none'
    },
    chartArea: {
        top: 8,
        bottom: 8,
        width: 600,
        height: 600,
    },
    pieHole: 0.41,
};

export const pieOptions = {
    slices: [
        {
            color: "#EE46BC"
        },
        {
            color: "#32B5D3"
        },
        {
            color: "#2E90FA"
        },
        {
            color: "#12B76A"
        },
        {
            color: "#CEEAB0"
        },
    ],
    legend: "none",
    tooltip: {
        showColorCode: true
    },
    chartArea: {
        top: 8,
        bottom: 8,
        width: 600,
        height: 600,
    },
    pieHole: 0.41,
};

export const pieOptionsDataNone = {
    slices: [
        {
            color: "#F2F2F2"
        },
    ],
    legend: "none",
    tooltip: {
        trigger: 'none'
    },
    chartArea: {
        top: 8,
        bottom: 8,
        width: 600,
        height: 600,
    },
    pieHole: 0.41,
};

export const overall_analytics_options = {
    legend: { position: 'top' },
    tooltip: {
        showColorCode: true
    },
    colors: ["#CD31BD", "#A2CB2C", "#D97C38", "#9B51E0","#2D9CDB"],
    timeline: { showBarLabels: true },
    pointSize: 5,
    vAxis: {title: "# of candidates"},
    hAxis: {title: "Month"}

};

export const shareable_link_analytics_options = {
    legend: { position: 'top' },
    tooltip: {
        showColorCode: true
    },
    colors: ["#FFA500", "#3B5998", "#A52A2A", "#0E76A8", "#556B2F"],
    timeline: { showBarLabels: true },
    pointSize: 5,
    vAxis: {title: "# of candidates"},
    hAxis: {title: "Month"}
};

export const offer_acceptance_rate_options = {
    legend: { position: 'top' },
    tooltip: {
        showColorCode: true
    },
    colors: ["#4D4CAC"],
    timeline: { showBarLabels: true },
    pointSize: 5,
    vAxis: {title: "percentage (%)"},
    hAxis: {title: "Month"}
};

export const selection_ratio_options = {
    legend: { position: 'top' },
    tooltip: {
        showColorCode: true
    },
    colors: ["#659CFF"],
    timeline: { showBarLabels: true },
    pointSize: 5,
    vAxis: {title: "percentage (%)"},
    hAxis: {title: "Month"}
};

export const time_to_hire_options = {
    legend: { position: 'top' },
    tooltip: {
        showColorCode: true
    },
    colors: ["#A065FF"],
    timeline: { showBarLabels: true },
    pointSize: 5,
    vAxis: {title: "days"},
    hAxis: {title: "Month"}
};


